<template>
    <div class="tab-container">
        <div class="tab" :class="{'active': active === index}"
            v-for="(tab,index) in tabsArr"
            :key="index"
            :style="widthComputed"
            @click="activeTab(index)"
        >
            <span> {{ tab }}    </span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Tab',
    props: {
      tabsArr: {
        type: Array,
      },
      selected: Number,
    },
    data() {
      return {
        active: 0,
      };
    },
    created() {
      if (this.selected) {
        this.active = this.selected;
      }
      this.$emit('active', this.active);
    },
    computed: {
      widthComputed() {
        const width = 100 / this.tabsArr.length;
        return `width: ${width}%`;
      },
    },
    methods: {
      activeTab(index) {
        this.active = index;
        this.$emit('active', this.active);
      },
    },
    watch: {
      selected(val) {
        if (val === 0 || val === 1) {
          this.active = val;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
@import "../../assets/styles/variables";

.tab-container {
    display: flex;
    background: $background-4;
    width: fit-content;
    border-radius: 63px;
    -webkit-box-shadow: 0px 8px 11px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 0px 8px 11px 0px rgba(0, 0, 0, 0.08);
    box-shadow: 0px 8px 11px 0px rgba(0, 0, 0, 0.08);
    .tab {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 130px;
        height: 40px;
        border-radius: 63px;
        background: $background-4;
        transition: all 0.2s ease-in-out;
        span {
            font-family: 'Roboto';
            font-size: 14px;
            line-height: 18px;
            display: flex;
            align-items: center;
            text-align: center;
            color: $text;
            border-radius: 16px;
        }
    }
    .active {
        background: $text-title;
        border-radius: 63px;
        span {
            color: $background-4;
        }
    }
}
</style>
